<template>
  <div class="flex-auto self-stretch flex">
    <div class="self-stretch flex flex-col lg:flex-row flex-nowrap w-full whitespace-pre-line bg-white leading-none rounded-l">
      <SortTextEntry  v-model="description"
                      :disabled="disabled"
                      :active="active"
                      class="w-full rounded-l"></SortTextEntry>
    </div>
  </div>
</template>

<script>
import SortTextEntry from '@/components/ui/SortTextEntry'

export default {
  name: 'RowDescription',
  components: {
    SortTextEntry
  },
  props: {
    value: String,
    active: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'DEFAULT'
    }
  },
  computed: {
    description: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      }
    }
  }
};
</script>
